import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const ParentMenu = () => {
  const routes = all_routes;

  // Mock data for children
  const [children] = useState([
    { id: "1", name: "Emma Johnson", grade: "10th", class: "10-A" },
    { id: "2", name: "James Johnson", grade: "8th", class: "8-B" },
  ]);

  const [selectedChildId, setSelectedChildId] = useState("1");

  const selectedChild = children.find((child) => child.id === selectedChildId);

  // Mock data for parent profile
  const parentProfile = {
    name: "John Johnson",
    email: "john.johnson@email.com",
    phone: "+1 (555) 123-4567",
    avatar: "assets/img/profiles/parent-01.jpg",
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Profile Section */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar avatar-lg me-3">
                  <img
                    src={parentProfile.avatar}
                    alt="Parent"
                    className="rounded-circle"
                  />
                </div>
                <div className="flex-fill">
                  <h5 className="mb-1">{parentProfile.name}</h5>
                  <p className="text-muted mb-1">{parentProfile.email}</p>
                  <p className="text-muted mb-0">{parentProfile.phone}</p>
                </div>
                <Link
                  to="/parent/profile"
                  className="btn btn-outline-primary btn-sm"
                >
                  <i className="ti ti-edit"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* Child Selector */}
          {children.length > 1 && (
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title mb-0">Select Child</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  {children.map((child) => (
                    <div key={child.id} className="col-md-6 mb-2">
                      <button
                        className={`btn w-100 ${
                          selectedChildId === child.id
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => setSelectedChildId(child.id)}
                      >
                        <i className="ti ti-user me-2"></i>
                        {child.name}
                        <br />
                        <small>
                          {child.grade} {child.class}
                        </small>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Academic & Daily Pages */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Academic & Daily</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/attendance-history"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-success-transparent me-3">
                      <i className="ti ti-calendar-check text-success"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Attendance History</h6>
                      <p className="text-muted mb-0">View attendance records</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/schedule"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-primary-transparent me-3">
                      <i className="ti ti-calendar text-primary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Full Schedule</h6>
                      <p className="text-muted mb-0">Weekly & monthly view</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/homework-history"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-warning-transparent me-3">
                      <i className="ti ti-book-2 text-warning"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Homework History</h6>
                      <p className="text-muted mb-0">Past assignments</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/grades-overview"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-info-transparent me-3">
                      <i className="ti ti-trophy text-info"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Grades & Exams</h6>
                      <p className="text-muted mb-0">Detailed grade reports</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/payments-history"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-secondary-transparent me-3">
                      <i className="ti ti-credit-card text-secondary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Payments History</h6>
                      <p className="text-muted mb-0">Payment records</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/documents"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-dark-transparent me-3">
                      <i className="ti ti-file-text text-dark"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Documents & Requests</h6>
                      <p className="text-muted mb-0">Manage documents</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <Link
                    to="/parent/events-calendar"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-purple-transparent me-3">
                      <i className="ti ti-calendar-event text-purple"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Events Calendar</h6>
                      <p className="text-muted mb-0">
                        School events & holidays
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Communication */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Communication</h5>
            </div>
            <div className="card-body">
              <Link
                to="/parent/messages"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
              >
                <div className="avatar avatar-sm bg-primary-transparent me-3">
                  <i className="ti ti-message text-primary"></i>
                </div>
                <div className="flex-fill">
                  <h6 className="mb-1">Messages</h6>
                  <p className="text-muted mb-0">Contact teachers & admin</p>
                </div>
                <span className="badge bg-primary">3</span>
              </Link>
            </div>
          </div>

          {/* Notifications & Tasks */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Notifications & Tasks</h5>
            </div>
            <div className="card-body">
              <Link
                to="/parent/notifications"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
              >
                <div className="avatar avatar-sm bg-warning-transparent me-3">
                  <i className="ti ti-bell text-warning"></i>
                </div>
                <div className="flex-fill">
                  <h6 className="mb-1">Notifications</h6>
                  <p className="text-muted mb-0">Past alerts & messages</p>
                </div>
                <span className="badge bg-warning">5</span>
              </Link>
              <Link
                to="/parent/tasks"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
              >
                <div className="avatar avatar-sm bg-info-transparent me-3">
                  <i className="ti ti-clipboard-list text-info"></i>
                </div>
                <div className="flex-fill">
                  <h6 className="mb-1">To-Do / Tasks</h6>
                  <p className="text-muted mb-0">Permissions & forms</p>
                </div>
                <span className="badge bg-info">2</span>
              </Link>
            </div>
          </div>

          {/* Settings & Support */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Settings & Support</h5>
            </div>
            <div className="card-body">
              <Link
                to="/parent/settings"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
              >
                <div className="avatar avatar-sm bg-secondary-transparent me-3">
                  <i className="ti ti-settings text-secondary"></i>
                </div>
                <div>
                  <h6 className="mb-1">Account Settings</h6>
                  <p className="text-muted mb-0">
                    Notifications, language, theme
                  </p>
                </div>
              </Link>
              <Link
                to="/parent/help"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
              >
                <div className="avatar avatar-sm bg-success-transparent me-3">
                  <i className="ti ti-help text-success"></i>
                </div>
                <div>
                  <h6 className="mb-1">Help / FAQ</h6>
                  <p className="text-muted mb-0">Get support & answers</p>
                </div>
              </Link>
              <button className="btn btn-danger w-100">
                <i className="ti ti-logout me-2"></i>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentMenu;
